// With a lot of help from:
// https://webdesign.tutsplus.com/tutorials/how-to-intersection-observer--cms-30250
// From: https://stuartcusack.ie/development-blog/tailwind-scroll-animations-using-an-intersection-observer
export class Animasection {

	constructor(options = {}) {

		// A nice way to initialise default options
		this.options = Object.assign(this, {
			root: null, // relative to document viewport
			rootMargin: '0px', // margin around root. Values are similar to css property. Unitless values not allowed
			threshold: 0.25 // visible amount of item shown in relation to root (higher values can cause problems)
		}, options);

		// This is the guy who will tell us when an element intersects with the viewport
		this.observer = new IntersectionObserver(this.onChange, this.options);
	}

	/**
	 * Observe all elements that contain either data-class-in or data-class-out
	 */
	observeAll() {
		// console.log('ObserveAlling');
		let elements = document.querySelectorAll('[data-class-in], [data-class-out], [data-class-in-only]');
		elements.forEach(el => this.observer.observe(el));
	}

	/**
	 * Unobserve all elements that contain either data-class-in or data-class-out
	 * Useful for optimisation / page transitions with swup / turbolinks
	 */
	unobserveAll() {
		let elements = document.querySelectorAll('[data-class-in], [data-class-out], [data-class-in-only]');
		elements.forEach(el => this.observer.unobserve(el));
	}

	/**
	 * The intersection observer will fire this function
	 * when at least one of our elements intersects / leaves the viewport
	 */
	onChange(changes, observer) {
		changes.forEach(change => {
			let classIn = change.target.dataset.classIn;
			let classOut = change.target.dataset.classOut;
			let classInOnly = change.target.dataset.classInOnly;
			/*
			 * 'split' turns our data attribute string into an array, and the spread operator (three dots)
			 * deconstructs it into the format that we need for manipulating the element's 'classList'
			 */
			if(change.isIntersecting) {
				if (classOut) change.target.classList.remove(...classOut.split(' '));
				if (classIn) change.target.classList.add(...classIn.split(' '));
				if (classInOnly) change.target.classList.add(...classInOnly.split(' '));
			} else {
				if (classIn) change.target.classList.remove(...classIn.split(' '));
				if (classOut) change.target.classList.add(...classOut.split(' '));
			}
		})
	}
}